import { render, staticRenderFns } from "./vBreadcrumbs.vue?vue&type=template&id=f5eb2fe2&scoped=true"
import script from "./vBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./vBreadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eb2fe2",
  null
  
)

export default component.exports